import React from 'react'

import { Container } from '@components/Container'
import { CharacterList } from '@features/character/components/CharacterList'
import { CharacterPageProps } from './interface'

export function CharacterPage(props: CharacterPageProps) {
  return (
    <Container className='tablet-mobile:px-[20px] desktop:py-[50px]'>
      <CharacterList {...props} />
    </Container>
  )
}
